import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Logo from "../Assets/logo.png";
import "./PurchasePrint.css";

const SalesGSTPrint = () => {
    const [salesData, setSalesData] = useState(null);
    const { filter } = useParams();

    const dummySalesData = {
        date: new Date().toISOString().split('T')[0],
        summary: {
            total_invoices: 8,
            grand_total: 150850.00,
            total_gst: 22850.00,
            total_taxable_value: 128000.00,
            total_cgst: 7155.00,
            total_sgst: 7155.00,
            total_igst: 8540.00,
            total_customers: 6,
            pending_payments: 2
        },
        transactions: [
            {
                id: 1,
                salesDate: "2025-11-21",
                invoiceNumber: "INV-S-001",
                customerName: "SSS Enterprises",
                customerGSTIN: "07AABCU9603R1ZM",
                taxableValue: 15000.00,
                cgstAmount: 1350.00,
                sgstAmount: 1350.00,
                igstAmount: 0.00,
                totalGST: 2700.00,
                totalAmount: 17700.00,
                salesType: "Regular",
                paymentStatus: "Paid"
            },
            {
                id: 2,
                salesDate: "2025-11-20",
                invoiceNumber: "INV-S-002",
                customerName: "ABC Traders",
                customerGSTIN: "27BXYPS1205Q2Z4",
                taxableValue: 8500.00,
                cgstAmount: 765.00,
                sgstAmount: 765.00,
                igstAmount: 0.00,
                totalGST: 1530.00,
                totalAmount: 10030.00,
                salesType: "Regular",
                paymentStatus: "Pending"
            },
            {
                id: 3,
                salesDate: "2025-11-19",
                invoiceNumber: "INV-S-003",
                customerName: "Global Exports",
                customerGSTIN: "09PQRSM7896L3T8",
                taxableValue: 25000.00,
                cgstAmount: 0.00,
                sgstAmount: 0.00,
                igstAmount: 4500.00,
                totalGST: 4500.00,
                totalAmount: 29500.00,
                salesType: "Interstate",
                paymentStatus: "Paid"
            },
            {
                id: 4,
                salesDate: "2025-11-18",
                invoiceNumber: "INV-S-004",
                customerName: "Metro Distributors",
                customerGSTIN: "24ABCDE1234F5G6",
                taxableValue: 12000.00,
                cgstAmount: 1080.00,
                sgstAmount: 1080.00,
                igstAmount: 0.00,
                totalGST: 2160.00,
                totalAmount: 14160.00,
                salesType: "Regular",
                paymentStatus: "Paid"
            },
            {
                id: 5,
                salesDate: "2025-11-17",
                invoiceNumber: "INV-S-005",
                customerName: "SSS Enterprises",
                customerGSTIN: "07AABCU9603R1ZM",
                taxableValue: 9000.00,
                cgstAmount: 810.00,
                sgstAmount: 810.00,
                igstAmount: 0.00,
                totalGST: 1620.00,
                totalAmount: 10620.00,
                salesType: "Regular",
                paymentStatus: "Paid"
            },
            {
                id: 6,
                salesDate: "2025-11-16",
                invoiceNumber: "INV-S-006",
                customerName: "National Retailers",
                customerGSTIN: "33MMTTS5566K9L0",
                taxableValue: 18000.00,
                cgstAmount: 1620.00,
                sgstAmount: 1620.00,
                igstAmount: 0.00,
                totalGST: 3240.00,
                totalAmount: 21240.00,
                salesType: "Regular",
                paymentStatus: "Pending"
            },
            {
                id: 7,
                salesDate: "2025-11-15",
                invoiceNumber: "INV-S-007",
                customerName: "International Buyers",
                customerGSTIN: "06NATSL7890M1N2",
                taxableValue: 35000.00,
                cgstAmount: 0.00,
                sgstAmount: 0.00,
                igstAmount: 6300.00,
                totalGST: 6300.00,
                totalAmount: 41300.00,
                salesType: "Interstate",
                paymentStatus: "Paid"
            },
            {
                id: 8,
                salesDate: "2025-11-14",
                invoiceNumber: "INV-S-008",
                customerName: "ABC Traders",
                customerGSTIN: "27BXYPS1205Q2Z4",
                taxableValue: 7000.00,
                cgstAmount: 630.00,
                sgstAmount: 630.00,
                igstAmount: 0.00,
                totalGST: 1260.00,
                totalAmount: 8260.00,
                salesType: "Regular",
                paymentStatus: "Paid"
            }
        ]
    };

    useEffect(() => {
        setSalesData(dummySalesData);
        setTimeout(() => window.print(), 800);
    }, [filter]);

    if (!salesData) return null;

    const getStatusColor = (status) => {
        switch(status) {
            case 'Paid': return '#28a745';
            case 'Pending': return '#ffc107';
            default: return '#6c757d';
        }
    };

    const getSalesTypeColor = (type) => {
        switch(type) {
            case 'Interstate': return '#17a2b8';
            case 'Regular': return '#007bff';
            default: return '#6c757d';
        }
    };

    return (
        <div className="print-page">
            {/* FULL PAGE BORDER */}
            <div className="page-border"></div>

            <div className="print-content">
                {/* HEADER */}
                <div className="header-section">
                    <div>GSTIN No: 33ABCDE1234F1Z5</div>
                    <div className="title">SALES GST REPORT</div>
                </div>

                {/* COMPANY BLOCK */}
                <div className="company-section">
                    <img src={Logo} width="70" alt="logo" />

                    <div className="company-details">
                        <h2>SDS POLYTECHNIC</h2>
                        <div>College Road, Campus Area</div>
                        <div>Coimbatore, Tamil Nadu - 641012</div>
                        <div>Mobile: 0422-1234567</div>
                    </div>
                </div>

                {/* REPORT INFO */}
                <div className="bill-info">
                    <div><b>Report Date:</b> {new Date(salesData.date).toLocaleDateString('en-IN')}</div>
                    <div><b>Generated On:</b> {new Date().toLocaleDateString('en-IN')}</div>
                    <div><b>Total Invoices:</b> {salesData.summary.total_invoices}</div>
                </div>

                {/* SUMMARY SECTION */}
                <div style={{ marginBottom: '15px', padding: '10px', border: '1px solid #000', fontSize: '13px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: '10px' }}>
                        <div><b>Grand Total:</b> ₹{salesData.summary.grand_total.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</div>
                        <div><b>Total GST:</b> ₹{salesData.summary.total_gst.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</div>
                        <div><b>Taxable Value:</b> ₹{salesData.summary.total_taxable_value.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</div>
                        <div><b>Total Customers:</b> {salesData.summary.total_customers}</div>
                        <div><b>Pending Payments:</b> {salesData.summary.pending_payments}</div>
                    </div>
                </div>

                {/* SALES TRANSACTIONS TABLE */}
                <table className="items-table">
                    <thead>
                        <tr>
                            <th>S.No</th>
                            <th>Sales Date</th>
                            <th>Invoice No</th>
                            <th>Customer Name</th>
                            <th>Customer GSTIN</th>
                            <th>Taxable Value</th>
                            <th>CGST</th>
                            <th>SGST</th>
                            <th>IGST</th>
                            <th>Total GST</th>
                            <th>Total Amount</th>
                            <th>Type</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {salesData.transactions.map((transaction, index) => (
                            <tr key={transaction.id}>
                                <td>{index + 1}</td>
                                <td><strong>{transaction.salesDate}</strong></td>
                                <td>{transaction.invoiceNumber}</td>
                                <td>{transaction.customerName}</td>
                                <td>{transaction.customerGSTIN}</td>
                                <td style={{ textAlign: 'right' }}>₹{transaction.taxableValue.toFixed(2)}</td>
                                <td style={{ textAlign: 'right' }}>{transaction.cgstAmount > 0 ? `₹${transaction.cgstAmount.toFixed(2)}` : '-'}</td>
                                <td style={{ textAlign: 'right' }}>{transaction.sgstAmount > 0 ? `₹${transaction.sgstAmount.toFixed(2)}` : '-'}</td>
                                <td style={{ textAlign: 'right' }}>{transaction.igstAmount > 0 ? `₹${transaction.igstAmount.toFixed(2)}` : '-'}</td>
                                <td style={{ textAlign: 'right', fontWeight: 'bold' }}>₹{transaction.totalGST.toFixed(2)}</td>
                                <td style={{ textAlign: 'right', fontWeight: 'bold' }}>₹{transaction.totalAmount.toFixed(2)}</td>
                                <td>
                                    <span style={{
                                        padding: '2px 8px',
                                        borderRadius: '12px',
                                        fontSize: '11px',
                                        fontWeight: 'bold',
                                        backgroundColor: getSalesTypeColor(transaction.salesType),
                                        color: 'white'
                                    }}>
                                        {transaction.salesType}
                                    </span>
                                </td>
                                <td>
                                    <span style={{
                                        padding: '2px 8px',
                                        borderRadius: '12px',
                                        fontSize: '11px',
                                        fontWeight: 'bold',
                                        backgroundColor: getStatusColor(transaction.paymentStatus),
                                        color: 'white'
                                    }}>
                                        {transaction.paymentStatus}
                                    </span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                {/* GST BREAKDOWN */}
                <div style={{ marginTop: '20px', fontSize: '13px' }}>
                    <b>GST Breakdown:</b>
                    <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', marginTop: '8px', gap: '10px' }}>
                        <div><b>CGST Total:</b> ₹{salesData.summary.total_cgst.toFixed(2)}</div>
                        <div><b>SGST Total:</b> ₹{salesData.summary.total_sgst.toFixed(2)}</div>
                        <div><b>IGST Total:</b> ₹{salesData.summary.total_igst.toFixed(2)}</div>
                        <div><b>Total GST:</b> ₹{salesData.summary.total_gst.toFixed(2)}</div>
                    </div>
                </div>

                {/* FINAL SUMMARY */}
                <div style={{ marginTop: '15px', padding: '8px', borderTop: '1px solid #000', fontSize: '13px', fontWeight: 'bold' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div>Net Sales Value (After GST):</div>
                        <div>₹{salesData.summary.grand_total.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</div>
                    </div>
                </div>

                {/* SIGNATURE */}
                <div className="signature-section">
                    <b>For SDS POLYTECHNIC</b>
                    <br /><br /><br />
                    <b>Authorized Signature</b>
                </div>

                <div className="footer-text">
                    This is a Computer Generated Sales GST Report
                </div>
            </div>
        </div>
    );
};

export default SalesGSTPrint;